import { Flex } from "@chakra-ui/react"

import Icon from "components/UI/atoms/Icon"
import Heading from "components/UI/atoms/Heading"
import { ICustomer } from "types/customer"

interface IActions {
  T: (key: string) => string
  handleBlockUnblockClick: (data: ICustomer) => void,
  handleDeleteClick: (data: ICustomer) => void,
}

export const getActions: any = ({ T, handleBlockUnblockClick, handleDeleteClick }: IActions) => {

  return [
    {
      key: "block",
      render: (data: ICustomer) => (
        <Flex gap={"10px"} alignItems={"flex-start"} justifyContent={"center"}>
          <Icon name="edit" iconStyles={{ fill: "#046CEC" }} />
          <Heading title={data.blocked ? T("actions.unblock") : T("actions.block")} variant="regular" size="sm" />
        </Flex>
      ),
      onClick: (data: any) => handleBlockUnblockClick(data)
    },
    {
      key: "delete",
      render: (data: ICustomer) => (
        <Flex gap={"10px"} alignItems={"flex-start"} justifyContent={"center"}>
          <Icon name="delete" iconStyles={{ fill: "#046CEC" }} />
          <Heading title={T("actions.delete")} variant="regular" size="sm" />
        </Flex>
      ),
      onClick: (data: any) => handleDeleteClick(data)
    },
  ]
}
